<template>
  <div class="headbox">
    <div class="headboxlogo">
        <div class="head">
        <div class="headmlogo"><img :src="hfliat.smallLogoNews" alt="" style="height:36px" @click="handlelitxq()" /></div>
        <div class="headllogo"><img :src="hfliat.bigLogoNews" alt="" /></div>
        <div class="headser">
          <div class="inpbox" @keyup.enter="serbtn">
            <input type="text" v-model="title" placeholder="请输入关键词"/>
            <button @click="serbtn">搜索</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 头部 -->
    <div class="minnav">
      <div class="mlogo">
        <img :src="hfliat.mobile_logo" style="height: 36px; margin: 7px 0 5px" alt="" @click="handlelitxq()" />
      </div>
      <div class="mnav" @click="drawer = true">
        <img src="@/assets/images/list.png" style="height: 17px; margin-top: 16px; margin-right: 15px" alt="" />
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="nav" v-show="isNavShwo">
      <div class="navbox">
        <ul class="navbul">
          <li>
            <router-link to="/home">
              <span>首&nbsp;&nbsp;&nbsp;&nbsp;页</span>
            </router-link>
          </li>
          <li v-for="(item,index) in menu_List" :key='index' @click="fn(item)" @mouseover="focusMenuName(item)">
            <el-dropdown>
              <span class="el-dropdown-link" >
                {{item.name}}
                <!-- <i class="el-icon--right"></i> -->
              </span>
              <el-dropdown-menu v-if="showdropdown" slot="dropdown" style="width: 120px">
                <el-dropdown-item v-for="(items,indexs) in item.subCates" :key="indexs" @click="fn(items)">
                  <div @click="fn(items)">
                      <span class="menuss">{{items.name}}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" :with-header="false" :modal-append-to-body="false">
      <el-collapse>
        <div class="leftitem" @click="handleheft()">首页</div>
        <el-collapse-item title="赢在成都" name="1">
          <div class="sfqitem" @click="fn(100)">成都概况</div>
          <div class="sfqitem" @click="fn(101)">发展环境</div>
          <div class="sfqitem" @click="fn(102)">产业成就</div>
        </el-collapse-item>

        <div class="leftitem" @click="fn(8)">时政要闻</div>
        <div class="leftitem" @click="fn(9)">行业资讯</div>
        <el-collapse-item title="专题活动" name="2">
          <div class="sfqitem" @click="fn(110)">建圈强链</div>
          <div class="sfqitem" @click="fn(111)">20+系列活动</div>
        </el-collapse-item>
        <div class="leftitem" @click="fn(11)">通知公告</div>
        <el-collapse-item title="产业政策" name="3">
          <div class="sfqitem" @click="fn(2000)">国家级</div>
          <div class="sfqitem" @click="fn(2001)">四川级</div>
          <div class="sfqitem" @click="fn(2002)">成都级</div>
        </el-collapse-item>
        <div class="leftitem" @click="fn(13)">产业动态</div>
        <div class="leftitem" @click="fn(14)">软件名城</div>
        <el-collapse-item title="产业服务" name="4">
          <div class="sfqitem" @click="fn(120)">企业服务</div>
          <div class="sfqitem" @click="fn(121)">行业统计</div>
          <div class="sfqitem" @click="fn(122)">蓉贝人才</div>
          <div class="sfqitem" @click="fn(123)">软洽会</div>
          <div class="sfqitem" @click="fn(124)">软件大赛</div>
          <div class="sfqitem" @click="fn(125)">信息通信大会</div>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>
  </div>
</template>
<script>
import { news, detail, MenuList } from "@/api/index.js";
export default {
  name: "headbox",
  data() {
    return {
      isNavShwo: true,
      issNavShwo: false,
      title: "",
      inplist: {
        siteId: 5,
        online: 1,
        enabled: 1,
        english: 0,
        title: "",
      },
      serlist: [],
      hfliat: [],
      drawer: false,
      menu_List:'',
      showdropdown:false,
    };
  },
  created() {
    this.handleheadfoot();
    this.getMenuList()
  },
  methods: {
    //导航栏的显示与隐藏
    shownav() {
      // this.isNavShwo = !this.isNavShwo;
      this.issNavShwo = !this.issNavShwo;
    },
    getMenuList() {
      MenuList({siteId:5}).then(res => {
        let menu_List = res.data.data
        this.menu_List = menu_List.map(item => {
          if(item.subCates.length == 0) {
            // Reflect.deleteProperty(item,"subCates");
            // document.querySelector('.el-popper').style.display = 'none'
          }
          return item
        })
        console.log(12363612,this.menu_List);
      })
    },
    focusMenuName(e) {
      this.$refs.messageDrop.hide()
      if(e.subCates.length !== 0) {
        this.showdropdown = true
      }else {
        this.showdropdown = false
      }
    },

    fn(e) {
      let id = e.id
      const obj = {
        100: "/cdgk",
        101: "fzhj",
        102: "cycj"
      };
      if(e.id == 100 || e.id == 101 || e.id == 102) {
        let goUrl = this.$router.resolve({path:obj[e.id],query: {id:id}})
        window.open(goUrl.href,'_blank')
      }else {
        //  判断是否有二级菜单
        if(e.subCates == undefined || e.subCates.length == 0 ) {
          // 一级菜单直接跳转页面
          let goUrl = this.$router.resolve({path:'/details',query: {id:id}})
          window.open(goUrl.href,'_blank')
        }
      }
    },
    handleheft(){
       this.$router.push({ path: "/home"});
    },
    // 获取搜索数据
    serbtn() {
        if(this.title == ""){
           this.$message({
            message: '请输入内容',
            type: 'warning'
          });
        }else{
          this.$router.push({ path: "/search", query: { title: this.title } });
           // 获取搜索数据
          news(this.inplist).then((res) => {
            this.serlist = res.data.data.records;
            this.inplist.total = res.data.data.total;
            if (res.data.data.total === 0) {
              this.value = true;
            } else {
              return;
            }
          });
        }

    },
    // 跳转首页
    handlelitxq() {
      this.$router.push({ path: "home" });
    },
    // 头部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
      });
    },
  },
};
</script>
<style lang="less">
.el-dropdown{
  width:100%;
}
.headbox{
  position: sticky;
  top:-103px;
}
.mlogo {
  margin-left: 10px;
}
.headboxlogo{
  background: #fff;
}
.head {
  max-width: 1200px;
  // min-width: 350px;
  background: #fff;
  margin: 0 auto;
  display: flex;
  text-align: left;
}
.headmlogo {
  flex: 3.2;
}
.nav1 {
  background: #0086e3;
  color: #fff;
}
.headmlogo > img {
  margin-top: 40px;
  cursor: pointer;
}
.headllogo {
  flex: 3.3;
}
.theadbachov{
  background: #ff9900;
}
.headser {
  flex: 3.5;
  margin-left: 19px;
}
.headllogo > img {
  margin: 40px 20px 0 50px;
  width:260px;
}
.inpbox {
  margin: 26px 0;
  border: 1px solid #eee;
  border-radius: 8px 8px 8px 8px;
  display: flex;
}
.inpbox > input {
  flex: 8.2;
  padding: 7px 7px 7px 14px;
  height: 49px;
  border: 0;
  font-size: 14px;
}
.inpbox > button {
  flex: 2.8;
  height: 49px;
  border: 1px solid #ff9900;
  background: #ff9900;
  border-radius: 0px 5px 5px 0px;
  color: #ffffff;
  font-size: 16px;
}
.navbul > li {
  font-weight: bold;
}
.navbul > li > a {
  color: #fff;
  font-weight: bold;
}
.navbul > li > div > span {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  display: block;
  width:100%;
}
.el-icon--right{
  display: none;
}
.el-dropdown-menu__item{
  // padding:0;
  text-align: center;
}
@media screen and (max-width: 1200px) {
  .headmlogo > img {
    width: 100%;
  }
  .headllogo > img {
    width: 100%;
    margin: 0;
    margin-top: 15px;
  }
  .inpbox > input {
    width: 100%;
  }
  .inpbox {
    margin: 0;
    margin-top: 15px;
  }
}
@media screen and (max-width: 900px) {
  .head {
    display: none;
  }
  .minnav {
    display: flex;
  }
  .nav {
    display: none;
  }
  .nav1 {
    display: block;
  }
  .navbul {
    display: block;
  }
}
.el-dropdown-menu .el-dropdown-menu__item {
  padding: 0 10px!important;
}
</style>
<style>
.el-drawer {
  width: 230px !important;
}
</style>
